import _objectSpread from "/var/www/html/civworks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/var/www/html/civworks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/var/www/html/civworks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classNames from 'classnames';
import * as React from 'react';
import { useCallback } from 'react';
import { ENTERED, ENTERING } from 'react-transition-group/Transition';
import transitionEndListener from './transitionEndListener';
import triggerBrowserReflow from './triggerBrowserReflow';
import TransitionWrapper from './TransitionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
var fadeStyles = _defineProperty(_defineProperty({}, ENTERING, 'show'), ENTERED, 'show');
var Fade = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _children = _ref.children,
    _ref$transitionClasse = _ref.transitionClasses,
    transitionClasses = _ref$transitionClasse === void 0 ? {} : _ref$transitionClasse,
    onEnter = _ref.onEnter,
    rest = _objectWithoutProperties(_ref, ["className", "children", "transitionClasses", "onEnter"]);
  var props = _objectSpread({
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
  }, rest);
  var handleEnter = useCallback(function (node, isAppearing) {
    triggerBrowserReflow(node);
    onEnter == null || onEnter(node, isAppearing);
  }, [onEnter]);
  return /*#__PURE__*/_jsx(TransitionWrapper, _objectSpread({
    ref: ref,
    addEndListener: transitionEndListener
  }, props, {
    onEnter: handleEnter,
    childRef: _children.ref,
    children: function children(status, innerProps) {
      return /*#__PURE__*/React.cloneElement(_children, _objectSpread({}, innerProps, {
        className: classNames('fade', className, _children.props.className, fadeStyles[status], transitionClasses[status])
      }));
    }
  }));
});
Fade.displayName = 'Fade';
export default Fade;